import "../../../libraries/jquery.scrollTo.min";
import nouisliderJs from '../../../libraries/nouislider.min';
import getParameterByName from './getParameterByName';
import tinyNavJs from '../../../libraries/tinynav.min';
import ActivateApptusTab from './activateApptusTab';
import resetSliderValues from './resetSliderValues';
import ChangePageModifier from './changePageModifier';
import InsertPager from './insertPager';
import initSelectForTabs from './initSelectForTabs';
import LoadMoreApptus from './loadMoreApptus';
import { GetTabProducts } from '../../toplist/toplist';

export default function tabsJs() {
  nouisliderJs();
  tinyNavJs();
  $(function () {
    $(".alpha-item").on("click", function () {
      $(".alpha-item").removeClass("active");
      $(this).addClass("active");
      LoadMoreApptus(1);
  
    });

    $(document.body).on('click',
     '#category-tabs .show_more span, #product-page .show_more a, #toplist-page .show_more a, #category-tabs .show_more a',
      function (e) {
      e.preventDefault();
  
      if ($(this).hasClass('disabled') || $(".profile-page").length > 0) {
        return false;
      }
  
      var page = parseInt($(this).data('page'));
      var methodname = $(this).parents('.pagination').data('methodname');

      
      switch(methodname) {
        case "LoadMoreApptus":
          LoadMoreApptus(page);
          break;
        case "GetTabProducts":
          GetTabProducts(page);
          break;
        default:
          console.log("We don't have such a function");
      }

      ChangePageModifier(page);
  
      if ($('#category-tabs').length) {
        $.scrollTo('#category-tabs', 0);
      }
      else if ($('#toplist-page').length) {
        $.scrollTo('#toplist', 0);
      }
      else {
        $.scrollTo('.tab-listing', 0);
      }
  
      return false;
    });
  
    window.addEventListener('popstate', function (event) {
  
      var page = getParameterByName("p");
      if (page && parseInt(page) > 0) {
        LoadMoreApptus(parseInt(page));
      }
  
    }, false);
    var isErotikOn = $.cookie('isErotikOn');
    if (isErotikOn && isErotikOn == "True" && !$('.erotik-view .show_erotik').prop("checked")) {
      $('.erotik-view .show_erotik').prop("checked", "true");
    }
  
  
    $('.erotik-view .show_erotik').on("click", function () {
      $('.erotik-view .show_erotik').not(this).prop("checked", $(this).prop("checked"));
      $('html, body').animate({ scrollTop: '0px' }, 0);
      var pageIndex = 1;
  
      HideEmptyTabs();
  
      LoadMoreApptus(pageIndex);
      
    });
  
    categoryTabsInit();

    categorySearchFilters();
  
    var url = window.location.pathname;
  
    window.addEventListener('scroll', function () {
      sessionStorage.setItem('productURL' + url, $(window).scrollTop());
    });
    
    $('.quantity-select.selVisaFler').on('change', function() {
      LoadMoreApptus(1);
    })

    if ($('#keypress').length) {
      initRangeSlider(0, 0, 0, 0);
    }

    if ($('#alphabet-filter').length) {
      $('#alphabet-filter').tinyNav();
    }

    filterAlphabetBtn();
    filterDiscountBtn();
    filterSearchBar();
    initSelectForTabs();
  });
      
      
  var categoryTabsInit = function () {
    var $categoryTabs = $('#category-tabs');
  
    if ($categoryTabs.length) {
      LoadMoreApptus($categoryTabs.data('pageindex'), $categoryTabs.data('currenttabname'));
  
      InsertPager($categoryTabs.data('productcount'), $categoryTabs.data('pageindex'));
  
      ActivateApptusTab($categoryTabs.data('currenttabname'), false);
  
      HideEmptyTabs();
    }
  }
  
  function filterDiscountBtn() {
    $('.discount-link').click(function (e) {
      ActivateApptusTab("SO_PLO2", true);
      e.preventDefault();
    });
  }
  
  function filterAlphabetBtn() {
    if ($(".alphabet-filter .tinynav:visible").length > 0) {
      $(document.body).on('change', '.alphabet-filter .tinynav', function (e) {
        ActivateApptusTab("SO_ARTA", true);
      });
  
    }
    else {
      $('.alphabet-filter li span').on("click", function (e) {
        $('.alphabet-filter li').removeClass("active");
        $(this).parent().addClass("active");
        ActivateApptusTab("SO_ARTA", true);
        e.preventDefault();
      });
    }
  }
  
  function filterSearchBar() {
    $('#search-input').on('keydown', function (e) {
      if (e.which == 13 && $(this).val() != "") {
        e.preventDefault();
        resetSliderValues();
        LoadMoreApptus(1);
      }
  
    });
    $('.search-panel .search-button').on('click tap', function (e) {
      resetSliderValues();
      LoadMoreApptus(1);
    });
  }
  
  function initRangeSlider(min, max, currMin, currMax) {
    var keypressSlider = document.getElementById('keypress');
    var input0 = document.getElementById('min_range');
    var input1 = document.getElementById('max_range');
    var inputs = [input0, input1];
  
    noUiSlider.create(keypressSlider, {
      start: [currMin, currMax],
      behaviour: 'snap',
      connect: true,
      range: {
        'min': [min],
        'max': max
      },
      format: wNumb({
        decimals: 0,
      })
    });
  
  
    keypressSlider.noUiSlider.on('update', function (values, handle) {
      inputs[handle].value = values[handle];
    });
  
    keypressSlider.noUiSlider.on('end', function () {
      LoadMoreApptus(1);
    });
  
    function setSliderHandle(i, value) {
      var r = [null, null];
      r[i] = value;
      keypressSlider.noUiSlider.set(r);
      LoadMoreApptus(1);
    }
  
    // Listen to keydown events on the input field.
    inputs.forEach(function (input, handle) {
  
      input.addEventListener('change', function () {
        setSliderHandle(handle, this.value);
      });
  
      input.addEventListener('keydown', function (e) {
  
        var values = keypressSlider.noUiSlider.get();
        var value = Number(values[handle]);
  
        // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
        var steps = keypressSlider.noUiSlider.steps();
  
        // [down, up]
        var step = steps[handle];
  
        var position;
  
        // 13 is enter,
        // 38 is key up,
        // 40 is key down.
        switch (e.which) {
  
          case 13:
            setSliderHandle(handle, this.value);
            e.preventDefault();
            break;
  
          case 38:
  
            // Get step to go increase slider value (up)
            position = step[1];
  
            // false = no step is set
            if (position === false) {
              position = 1;
            }
  
            // null = edge of slider
            if (position !== null) {
              setSliderHandle(handle, value + position);
            }
  
            break;
  
          case 40:
  
            position = step[0];
  
            if (position === false) {
              position = 1;
            }
  
            if (position !== null) {
              setSliderHandle(handle, value - position);
            }
  
            break;
        }
      });
    });
  }

  function HideEmptyTabs() {
    $(".apptus-tab").each(function () {
      if (!$(this).is(":visible")) {
        $(this).parent().show();
      }
    });
  
    $.ajax({
      url: "/api/Apptus/EmptyTabs",
      async: true,
      dataType: 'json',
      success: function (data) {
        if (data != null && data.EmptyTabs != null) {
          var tabs = data.EmptyTabs;
          if (tabs.length) {
            for (var i = 0; i < tabs.length; i++) {
              $("ul.tabs-nav li#" + tabs[i].Id).hide();
            }
          }
        }
      }
    });
  }

  function categorySearchFilters() {
    var $tabWrapper = $('#category-tabs.tab-frame'),
      $tabMenuLink = $tabWrapper.find('.tab-panel .tabs-nav span'),
      $tabControlLink = $tabWrapper.find('.tab-panel .ctrl-btn-panel span');
  
    $tabControlLink.on('click', function (event) {
      event.preventDefault();
  
      var before = $('.tab-panel .ctrl-btn-panel li.active').not(".search");
      before.removeClass('active');
      $(this).parent().addClass('active');
  
    });
    $tabMenuLink.on('click', function (event) {
      event.preventDefault();
      var before = $('.tabs-nav li.active');
      before.removeClass('active');
      $(this).parent().addClass('active');
  
      var dataAttrViewMode = $(this).attr("data-btn");
      if (dataAttrViewMode) {
        $tabWrapper.removeClass('func-range-slider func-alphabet-search filter-active').addClass(dataAttrViewMode + ' filter-active');
      }
      else {
        $tabWrapper.removeClass('func-range-slider func-alphabet-search filter-active');
      }
  
      ActivateApptusTab($(this).parent().attr("id"), true);
    });
  }
}
